import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';

export default function HandoffCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get('access_token');
    const next = params.get('next') || '/super-admin';
    if (!token) {
      navigate('/login', { replace: true });
      return;
    }
    localStorage.setItem('sf_token', token);
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    api.get('/auth/me')
      .then((res) => {
        localStorage.setItem('sf_user', JSON.stringify(res.data));
        window.location.replace(next);
      })
      .catch(() => {
        localStorage.removeItem('sf_token');
        navigate('/login', { replace: true });
      });
  }, [navigate, params]);

  return (
    <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">
      Completing secure sign-in…
    </div>
  );
}
